var cancelVideo = 0;
var clickedModal = true;
var setted = false;
document.addEventListener('DOMContentLoaded', () => {

  window.addEventListener('resize', function () {
    var vw = window.innerWidth / 100; // Convert vw to percentage
    var paragraphHeight = (-7 * Math.pow(10, -5) * Math.pow(100 * vw, 2)) + (0.2094 * 100 * vw) - 99.371;
    var paragraphs = document.querySelectorAll('.swiper_videos__titulo p');
    paragraphs.forEach(function (paragraph) {
      if (window.innerWidth < 800) {
        paragraph.style.height = '';
      }else if (window.innerWidth < 1562) {
        paragraph.style.height = paragraphHeight + 6 + 'px';
      } else {
        paragraph.style.height = 62 + 'px';
      }
    })

    let caixas = document.querySelectorAll('swiper-container');
    if (window.innerWidth < 801) {
      caixas.forEach(function (caixa) {
        caixa.setAttribute('slides-per-view', '1');
        caixa.style.opacity = '1';
      })
    } else {
      caixas.forEach(function (caixa) {
        caixa.setAttribute('slides-per-view', '3');

      })
      if (!setted) {
        setted = true;
        var time = 0;


        caixas.forEach(function (caixa) {
          setTimeout(function () {
            time = time + 1000;
            let previous = caixa.shadowRoot.querySelectorAll('.swiper-button-prev');
            previous.forEach(function (prev) {
              prev.dispatchEvent(new Event('click'));
            });
            caixa.style.opacity = '1';
          }, time - 500)
        });

      }

    }
  })
  var ResizeEvent = new Event('resize');
  window.dispatchEvent(ResizeEvent);

  if (document.getElementsByClassName('page-furb-noticias')) {
    const videocards = document.querySelectorAll('.swiper_videos__video');

    const findVideoHref = (event) => {
      document.addEventListener("keydown", function (event) {
        if (event.key === "Escape" || event.keyCode === 27) {
          cancelAllVideos();
        }
      });

      function cancelAllVideos() {
        const allVideos = document.querySelectorAll('.youtube-iframe');
        allVideos.forEach(function (video) {
          video.setAttribute('src', '');
        })
      }

      const cardDataTarget = event.currentTarget.getAttribute('data-target');
      // Your logic to handle the video href using cardDataTarget
      const modal = document.querySelector(cardDataTarget);
      const modalDialog = modal.querySelector('.modal-dialog')
      const modalClose = modal.querySelector('.close-video');
      modalClose.addEventListener('click', function () {
        cancelAllVideos();
      })
      modal.addEventListener('click', function () {

        if (!clickedModal) {
          cancelVideo = true;
          clickedModal = true;
        }

        setTimeout(function () {
          if (!modal.classList.contains('show')) {
            cancelAllVideos();
          }

        }, 200)
      })
      modalDialog.addEventListener('click', function () {
        cancelVideo = false;
      })
      modalClose.addEventListener('click', function () {
        cancelAllVideos();
      })
      var modalUrl = modal.querySelector('.iframe-url').innerHTML;
      if (!modalUrl.includes('embed')) {
        const videoId = modalUrl.split('=')[1];
        modalUrl = 'https://www.youtube.com/embed/' + videoId;
      }
      const youtubeIframe = modal.querySelector('.youtube-iframe');
      youtubeIframe.setAttribute('src', modalUrl);
    };

    videocards.forEach((card) => {
      card.addEventListener('click', findVideoHref);
    });
  }
});
